import { render, staticRenderFns } from "./SalesReturnList.vue?vue&type=template&id=493443d5&"
import script from "./SalesReturnList.vue?vue&type=script&lang=js&"
export * from "./SalesReturnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SalesReturnList.vue"
export default component.exports